import React, { useState, useEffect } from 'react';

const Contact = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return (
        <section style={isMobile ? {...styles.section, ...styles.sectionMobile} : styles.section}>
        <div style={styles.overlay}></div>
        <div style={styles.container}>
            <h2 style={isMobile ? {...styles.title, ...styles.titleMobile} : styles.title}>CONTACT</h2>
            <img style={styles.img} src="/images/contact/IMAGE-CONTACT.jpg" alt="contact" />
            <div style={isMobile ? {...styles.contactCard, ...styles.contactCardMobile} : styles.contactCard}>
            <h3 style={isMobile ? {...styles.contactTitle, ...styles.contactTitleMobile} : styles.contactTitle}>
                Email
            </h3>
            <a 
                href="mailto:aloha.panteramg@gmail.com"
                style={isMobile ? {...styles.contactLink, ...styles.contactLinkMobile} : styles.contactLink}
            >
                aloha.panteramg@gmail.com
            </a>
            </div>
            
            <div style={isMobile ? {...styles.contactCard, ...styles.contactCardMobile} : styles.contactCard}>
            <h3 style={isMobile ? {...styles.contactTitle, ...styles.contactTitleMobile} : styles.contactTitle}>
                Instagram
            </h3>
            <a 
                href="https://instagram.com/panteramg.music"
                target="_blank"
                rel="noopener noreferrer"
                style={isMobile ? {...styles.contactLink, ...styles.contactLinkMobile} : styles.contactLink}
            >
                @panteramg.music
            </a>
            </div>
        </div>
        </section>
    );
};

const styles = {
    section: {
        minHeight: '100vh',
        background: '#000',
        padding: '100px 2rem 4rem',
        fontFamily: 'Roboto, sans-serif',
    },
    sectionMobile: {
        padding: '80px 1rem 2rem',
    },
    overlay: {
        position: 'absolute',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.25)',
    },
    container: {
        position: 'relative',
        zIndex: 1,
        maxWidth: '800px',
        margin: '0 auto',
        padding: '0 1rem',
    },
    title: {
        fontSize: '3rem',
        color: '#fff',
        letterSpacing: '0.3rem',
        textAlign: 'center',
        marginBottom: '3rem',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 700,
    },
    titleMobile: {
        fontSize: '2rem',
        letterSpacing: '0.15rem',
        marginBottom: '2rem',
    },
    img:{
        width: '100%',
        marginBottom: '3rem',
        borderRadius: '10px',
    },
    contactCard: {
        background: 'rgba(17,17,17,0.85)',
        padding: '3rem',
        borderRadius: '10px',
        textAlign: 'center',
        marginBottom: '2rem',
    },
    contactCardMobile: {
        padding: '2rem 1.5rem',
    },
    contactTitle: {
        fontSize: '1.5rem',
        color: '#fff',
        marginBottom: '1rem',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 500,
    },
    contactTitleMobile: {
        fontSize: '1.2rem',
    },
    contactLink: {
        fontSize: '1.5rem',
        color: '#4a9eff',
        textDecoration: 'none',
        transition: 'color 0.3s',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 400,
        wordBreak: 'break-word',
    },
    contactLinkMobile: {
        fontSize: '1.1rem',
    },
};

export default Contact;